import { Route, Routes } from "react-router-dom";
import Homepage from "../Homepage/Homepage";
import SlotPage from "../BookyourSlot/SlotPage";
import Registration from "../RegistrationForm/Registration";
import { EmergencyContact } from "../RegistrationForm/EmergencyContact";
import PersonalInformation from "../RegistrationForm/PersonalInformation";
import { MedicalInformation } from "../RegistrationForm/MedicalInformation";
import { Membership } from "../RegistrationForm/Membership";
import ContactUs from "../ContactUsForm/ContactUs";
import AccessoriesPage from "../AccessoriesPage/Accessories";
import { NewHomePage } from "../NewHomePage/NewHomePage";
import Admin from "../Admin/AdminPage/Admin";
import Login from "../Login/Login";
import { FormProvider } from "../Context/FormContext";
import CancelationForm from "../CancellationForm/CancellationForm";



const Navigation = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/accessories" element={<AccessoriesPage />} />
        <Route path="slotpage" element={<SlotPage />} />

        <Route
          path="/registration"
          element={
            <FormProvider>
              <Registration />
            </FormProvider>
          }
        >
          <Route index element={<PersonalInformation />} />
          <Route path="personalinformation" element={<PersonalInformation />} />
          <Route path="emergencycontact" element={<EmergencyContact />} />
          <Route path="medicalinformation" element={<MedicalInformation />} />
          <Route path="membership" element={<Membership />} />
        </Route>

        <Route path="/contactus" element={<ContactUs />} />
        <Route path="kbaacademy" element={<NewHomePage />} />
        <Route path="/admin/adminpage" element={<Admin />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/Cancellationform" element={<CancelationForm/>}/>
      </Routes>
    </div>
  );
};

export default Navigation;
